import React from "react";
import Cropper from "react-easy-crop";
import { CropOverlay } from "./CropOverlay";
import { CropperWrapper, ImagePickerLabel, ImageButton, ZoomControls, ZoomButton } from "./ModalCrop.style";
/**
 * - CropperSection is custom overlay (CropOverlay) section for displaying and  show the crop area and handle circle-based cropping.
 * - The canvas cropper will appear in the center, allowing you to drag your image to adjust the display.
 * - You can also zoom in for better quality and select the desired position and aspect ratio
**/

export const PlusIcon = () => (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="2" width="2" height="12" fill="currentColor" />
        <rect x="2" y="7" width="12" height="2" fill="currentColor" />
    </svg>
);

export const MinusIcon = () => (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="7" width="12" height="2" fill="currentColor" />
    </svg>
);

export const CropperSection = ({
    imageSrcInternal,
    crop,
    zoom,
    setCrop,
    setZoom,
    computedAspect,
    handleCropComplete,
    handleCropSizeChange,
    cropBoxSize,
    setImageSrcInternal,
    isCircle
}) => {

    const MIN_ZOOM = 1;
    const MAX_ZOOM = 3;
    const ZOOM_STEP = 0.1;

    const zoomIn = () => {
        setZoom(prev => Math.min(prev + ZOOM_STEP, MAX_ZOOM));
    };

    const zoomOut = () => {
        setZoom(prev => Math.max(prev - ZOOM_STEP, MIN_ZOOM));
    };

    return (
        <CropperWrapper>
            <ImagePickerLabel htmlFor="image-picker">
                <input
                    id="image-picker"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                            const reader = new FileReader();
                            reader.onload = () => {
                                if (typeof reader.result === "string") {
                                    setImageSrcInternal(reader.result);
                                }
                            };
                            reader.readAsDataURL(file);
                        }
                    }}
                />
                <ImageButton>Image</ImageButton>
            </ImagePickerLabel>
            <div title="Hold and drag to reposition the image within the crop area">
                <Cropper
                    image={imageSrcInternal}
                    crop={crop}
                    zoom={zoom}
                    aspect={computedAspect}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={handleCropComplete}
                    onCropSizeChange={handleCropSizeChange}
                    showGrid={false}
                    style={{
                        containerStyle: {
                            backgroundColor: "transparent",
                        },
                    }}
                />
            </div>
            <CropOverlay width={cropBoxSize.width} height={cropBoxSize.height} isCircle={isCircle} />

            {/* Zoom Controls */}
            <ZoomControls>
                <ZoomButton
                    onClick={zoomOut}
                    disabled={zoom <= MIN_ZOOM}
                    aria-label="Zoom Out"
                >
                    <MinusIcon />
                </ZoomButton>

                <ZoomButton
                    onClick={zoomIn}
                    disabled={zoom >= MAX_ZOOM}
                    aria-label="Zoom In"
                >
                    <PlusIcon />
                </ZoomButton>
            </ZoomControls>

        </CropperWrapper>
    );
};
